import clsx from "clsx";
import { Button } from "components/Button";
import { useNetworksStore } from "store/networksStore";
import { Fee } from "types/fee";

export const FeeComponent: React.FC<{
  fee: Fee;
  onChange: (index: number, field: keyof Fee, newValue: string) => void;
  onRemove: (index: number) => void;
  index: number;
  disabled: boolean;
}> = ({ fee, onChange, onRemove, index, disabled }) => {
  const { currentNetwork } = useNetworksStore();
  const currencyDecimals = currentNetwork.depositTokens[0].decimals;

  return (
    <div className="mb-2 flex items-end gap-4">
      <span>{index + 1}.</span>
      <label className="flex flex-col gap-1">
        From ($):
        <input
          disabled={disabled || !index}
          type="text"
          value={fee.from}
          placeholder={!index ? `1e-${currencyDecimals}` : "0"}
          onChange={(e) => onChange(index, "from", e.target.value)}
          className={`flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none transition-opacity duration-300 focus:border-gray-700 disabled:opacity-60 `}
        />
      </label>

      <label className="flex flex-col gap-1">
        Percentage (%):
        <input
          type="text"
          value={fee.percentage}
          placeholder="0"
          onChange={(e) => onChange(index, "percentage", e.target.value)}
          className={clsx(
            `flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none transition-opacity duration-300 focus:border-gray-700 `,
            parseFloat(fee.percentage) &&
              parseFloat(fee.fixedFee) &&
              "border-red-500 text-red-500 focus:!border-red-500"
          )}
        />
      </label>

      <label className="flex flex-col gap-1">
        Fixed Fee ($):
        <input
          type="text"
          value={fee.fixedFee}
          placeholder="0"
          onChange={(e) => onChange(index, "fixedFee", e.target.value)}
          className={clsx(
            `flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none transition-opacity duration-300 focus:border-gray-700 `,
            parseFloat(fee.percentage) &&
              parseFloat(fee.fixedFee) &&
              "border-red-500 text-red-500 focus:!border-red-500"
          )}
        />
      </label>

      <Button
        onClick={() => onRemove(index)}
        className=" h-12 bg-red-500"
        disabled={disabled}
      >
        Remove
      </Button>
    </div>
  );
};
